import { lazy } from "react"
import { OysterRouter } from "~/router/type"
import { LazyLoadingSuspenseWithErrorBoundary } from "@oysterhr/feature-components"

const OffboardingPage = lazy(() => import("./pages/OffboardingPage"))
const BulkOffboardingDetail = lazy(() => import("./pages/Bulk/BulkOffboardingDetail"))
const EditBulkOffboarding = lazy(() => import("./pages/EditBulkOffboarding"))
const AdminOffboardingFlow = lazy(() => import("./pages/AdminOffboardingFlow"))
const BulkAddTeamMembersToInProgress = lazy(
  () => import("./pages/Bulk/BulkAddTeamMembersToInProgress"),
)

export const staffOffBoardingRoutes: OysterRouter = {
  DeprecatedLeftSidebar: [
    {
      path: "offboarding",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <OffboardingPage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
    {
      path: "offboarding/bulk-offboarding/:bulkOffboardingStrongId",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <BulkOffboardingDetail />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
  ],
  DeprecatedFullScreen: [
    {
      path: "offboarding/bulk-offboarding/:bulkOffboardingStrongId/edit",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <EditBulkOffboarding />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
    {
      path: "offboarding/bulk-offboarding/:bulkOffboardingStrongId/add-team-members",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <BulkAddTeamMembersToInProgress />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
    {
      path: "companies/:companyStrongId/employments/:employmentStrongId/offboarding",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <AdminOffboardingFlow />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
  ],
}
